/**
 * Maps the backend's technical `currentStep` text (for example "Splitting audio into 17 segments")
 * to one short line a person can read. Matching is case-insensitive and the first rule that matches
 * wins. The finishing rule is first because its steps also name the transcript ("Applying AI transcript
 * correction", "Uploading transcription output"), which the transcription rule would otherwise claim.
 */
const STATUS_RULES: ReadonlyArray<{ pattern: RegExp; message: string }> = [
  { pattern: /correct|format|docx|document|transcription output/i, message: "Finishing your transcript..." },
  { pattern: /upload/i, message: "Uploading audio..." },
  { pattern: /split|convert/i, message: "Preparing audio..." },
  { pattern: /transcri|speaker/i, message: "Generating transcription..." },
];

export const FALLBACK_STATUS = "Processing audio...";

export function toFriendlyStatus(currentStep?: string | null): string {
  const step = typeof currentStep === "string" ? currentStep : "";
  const rule = STATUS_RULES.find(({ pattern }) => pattern.test(step));
  return rule ? rule.message : FALLBACK_STATUS;
}
